import { Chip, ListSubheader, MenuItem, styled } from 'opensolar-ui'
import type { ReactNode } from 'react'
import type { ContractTemplateListItem, TranslateFn } from '../../utils/contractTemplateUtils'
import type { ContractSelectSection } from '../../utils/entitySharingUtils'

const SectionHeadingRow = styled('span')(
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: '8px',
    fontSize: '14px',
  },
  { name: 'SectionHeadingRow' }
)

const SectionHeadingTitle = styled('span')(
  {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  { name: 'SectionHeadingTitle' }
)

const SectionHeadingSubheader = styled(ListSubheader)(
  {
    width: '100%',
    paddingLeft: '1em',
    display: 'block',
    color: 'rgba(0, 0, 0, 0.58)',
    opacity: 1,
    lineHeight: 'inherit',
    paddingRight: '8px',
  },
  { name: 'SectionHeadingSubheader' }
)

export type GroupedContractMenuItemsProps = {
  sections: ContractSelectSection[]
  getValue: (contract: ContractTemplateListItem) => string
  translate: TranslateFn
}

const renderGroupedContractMenuItems = ({
  sections,
  getValue,
  translate,
}: GroupedContractMenuItemsProps): ReactNode[] =>
  sections.flatMap((section) => {
    const nodes: ReactNode[] = []

    if (!section.hideHeader) {
      nodes.push(
        <SectionHeadingSubheader disableSticky key={`heading-${section.id}`}>
          <SectionHeadingRow>
            <SectionHeadingTitle>{section.name}</SectionHeadingTitle>
            {section.chip && <Chip label={translate(section.chip)} size="small" variant="outlined" disabled />}
          </SectionHeadingRow>
        </SectionHeadingSubheader>
      )
    }

    section.contracts.forEach((contract) => {
      nodes.push(
        <MenuItem key={contract.id} value={getValue(contract)}>
          {contract.title}
        </MenuItem>
      )
    })

    return nodes
  })

export default renderGroupedContractMenuItems
